"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
exports.__esModule = true;
exports.getRandomColor = exports.getPrefix = void 0;
var ThemeProvider_1 = require("./ThemeProvider");
var getPrefix = function (props) {
    return props.theme.prefix;
};
exports.getPrefix = getPrefix;
var COLORS = [
    (_a = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _a === void 0 ? void 0 : _a.green,
    (_b = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _b === void 0 ? void 0 : _b.bostonblue,
    (_c = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _c === void 0 ? void 0 : _c.purple,
    (_d = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _d === void 0 ? void 0 : _d.pink,
    (_e = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _e === void 0 ? void 0 : _e.lightblue,
    (_f = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _f === void 0 ? void 0 : _f.blue,
    (_g = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _g === void 0 ? void 0 : _g.lavender,
    (_h = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _h === void 0 ? void 0 : _h.red,
    (_j = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _j === void 0 ? void 0 : _j.red,
    (_k = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _k === void 0 ? void 0 : _k.cyan,
    (_l = ThemeProvider_1.DefaultEpilotTheme.palette) === null || _l === void 0 ? void 0 : _l.orange
];
var getRandomColor = function (seed) {
    var rand = parseInt(seed, 36);
    return COLORS[rand ? rand % COLORS.length : 0];
};
exports.getRandomColor = getRandomColor;
//# sourceMappingURL=utils.js.map